const NORMAL = Math.sqrt(5);
const OFFSETS = [[0, 0], [48, -24], [48, 24], [-48, 24], [-48, -24],
  [96, 0], [0, 48], [-96, 0], [0, -48]] as const;
const EDGES = [[], [0], [1], [2], [3], [0, 1], [1, 2], [2, 3], [3, 0]] as const;
const NORMALS = [[-1 / NORMAL, 2 / NORMAL], [-1 / NORMAL, -2 / NORMAL],
  [1 / NORMAL, -2 / NORMAL], [1 / NORMAL, 2 / NORMAL]] as const;

/** Pixel-centre location inside the material supplying this neighborhood contribution. */
export function biomeFloorSamplePoint(index: number, px: number, py: number,
  distances: readonly number[]): readonly [number, number] {
  // Diagonal cells touch at a point. A half-turn maps that shared corner into
  // the opposite source corner; adding two edge reflections can leave the diamond.
  if (index >= 5) return [96 - px, 48 - py];
  const [ox, oy] = OFFSETS[index]!;
  let x = px - ox, y = py - oy;
  for (const edge of EDGES[index]!) {
    const [nx, ny] = NORMALS[edge]!;
    x -= 2 * distances[edge]! * nx;
    y -= 2 * distances[edge]! * ny;
  }
  return [x, y];
}
